// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        classId: "0",
        capacity: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.classId !== undefined)
        result.classId = tsValueToJsonValueFns.int64(value.classId);
    if (value.capacity !== undefined)
        result.capacity = tsValueToJsonValueFns.int64(value.capacity);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.classId !== undefined)
        result.classId = jsonValueToTsValueFns.int64(value.classId);
    if (value.capacity !== undefined)
        result.capacity = jsonValueToTsValueFns.int64(value.capacity);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.classId !== undefined) {
        const tsValue = value.classId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.capacity !== undefined) {
        const tsValue = value.capacity;
        result.push([2, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.classId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.capacity = value;
    }
    return result;
}
